// import { reportTraining } from '@/api/modules/training';
import { repoExamLog } from '@/api/modules/community';
import { useEffect, useRef } from 'react';

// 批量考试，点对点考试，实验
const useSystemEventListener = () => {
  const listenersActive = useRef(false)
  const data = useRef<any>()

  // 处理复制事件
  const handleCopy = (e: Event) => {
    if (data.current?.type === 'training') {
      // reportTraining(data.current?.meta?.trainingId, { userAction: 'COPY' }).catch(() => { })
    } else {
      repoExamLog({
        action: 'COPY',
        examRecordCode: data.current?.meta?.examRecordCode
      }).catch(() => { })
    }
  };

  // 处理粘贴事件
  const handlePaste = (e: Event) => {
    if (data.current?.type === 'training') {
      // reportTraining(data.current?.meta?.trainingId, { userAction: 'PASTE' }).catch(() => { })
    } else {
      repoExamLog({
        action: 'PASTE',
        examRecordCode: data.current?.meta?.examRecordCode
      }).catch(() => { })
    }
  };

  // 处理剪切事件
  const handleCut = (e: Event) => {
    // console.log('剪切事件:', e);
  };

  // 处理切屏事件
  const handleVisibilityChange = (e: Event) => {
    if (document.visibilityState === 'hidden') {
      if (data.current?.type === 'training') {
        // reportTraining(data.current?.meta?.trainingId, { userAction: 'LEAVE' }).catch(() => { })
      } else {
        repoExamLog({
          action: 'LEAVE',
          examRecordCode: data.current?.meta?.examRecordCode
        }).catch(() => { })
      }
    } else if (document.visibilityState === 'visible') {
      if (data.current?.type === 'training') {
        // reportTraining(data.current?.meta?.trainingId, { userAction: 'STAY' }).catch(() => { })
      } else {
        repoExamLog({
          action: 'STAY',
          examRecordCode: data.current?.meta?.examRecordCode
        }).catch(() => { })
      }
    }
  };

  // 开始监听所有事件
  const startListening = (type: 'batch' | 'point' | 'training', meta?: any) => {
    if (listenersActive.current) return;
    data.current = {
      type,
      meta
    }
    window.addEventListener('copy', handleCopy);
    window.addEventListener('paste', handlePaste);
    window.addEventListener('cut', handleCut);
    window.addEventListener('visibilitychange', handleVisibilityChange);
    listenersActive.current = true;
  };

  // 取消监听所有事件
  const stopListening = () => {
    if (!listenersActive.current) return;
    data.current = null;
    window.removeEventListener('copy', handleCopy);
    window.removeEventListener('paste', handlePaste);
    window.removeEventListener('cut', handleCut);
    window.removeEventListener('visibilitychange', handleVisibilityChange);
    listenersActive.current = false;
  };

  // 组件卸载时自动取消监听
  useEffect(() => {
    return () => {
      stopListening();
    };
  }, []);

  return {
    startListening,
    stopListening
  };
};

export default useSystemEventListener;